import { baseUrl } from "./BaseUrl";

export const loginApi = baseUrl + "/auth/admin-login"
export const changePasswordApi = "admin/change-password"

//=============== Dashboard ================
export const getDashboardapi = "admin/get-dashboard"

//=================== User ==================
export const getUserApi = "admin/get-user"
export const getUserLevelsApi = "admin/get-user-levels"
export const addAminBonusApi = "/add-admin-bonus"
export const getYoutubeUserApi = "/get-youtube-user"
export const getAllUserByIdApi = "/get-all-user-by-id"
export const updateUserApi = "admin/update-user"
export const blockUserApi = "admin/update-user-status"
export const getUserWalletApi = "admin/get-user-wallet"
export const exportUsersApi = "admin/user-excel-create"
export const updateRestrictApi = "admin/update-restrict"
export const getUserStakingApi = "admin/get-user-staking"
export const getUserStakingTransactionsApi = "admin/get-user-staking-transactions"
export const getUserEtokenBalancesApi = "admin/get-user-etoken-balances"
export const getStakingTransactionsApi = "admin/get-staking-transactions"
export const getAllUsersListApi = "admin/get-all-users-list"
export const getUsersWatchPointsHistoryApi = "admin/get-users-watch-points-history"
export const getUsersDailyBonusHistoryApi = "admin/get-users-daily-bonus-history"



//=================== Network ==================
export const getNetworkApi = "admin/get-networks"
export const updateNetworkApi = "admin/update-network"

//=================== Cryptocurrency ==================
export const getCryptocurrencyApi = "admin/get-cryptocurrencies"
export const addCryptocurrencyApi = "admin/add-cryptocurrency"
export const updateCryptocurrencyApi = "admin/update-cryptocurrency"
export const getContractDetailsApi = "admin/get-contract-details"
export const changeCryptoStatusApi = "admin/change_crypto_status"

//=================== Swap ==================
export const getSwapApi = "admin/get-swaps"
export const addSwapApi = "admin/add-swap"
export const updateSwapApi = "admin/update-swap"
export const deleteSwapApi = "admin/delete_swap_rate"

//=================== Reward Settings ==================
export const getRewardSettingsApi = "admin/get-reward-settings"
export const addRewardSettingsApi = "admin/add-reward-settings"
export const updateRewardSettingsApi = "admin/update-reward-settings"
export const updateRewardSettingsStatusApi = "admin/update-reward-settings-status"
export const getReferralLevelsApi = "admin/get-referral-levels"


//=================== Reward Transaction ==================
export const getRewardTransactionsApi = "admin/get-reward-transactions"

//=================== Staking Plan ==================
export const getStakingPlanApi = "admin/get-staking-plans"
export const addStakingPlanApi = "admin/add-staking-plan"
export const updateStakingPlanApi = "admin/update-staking-plan"

//=================== Ads Settings ==================
export const getAdsSettingsApi = "admin/get-ads-settings"
export const updateAdsSettingsApi = "admin/update-ads-settings"

//=================== Ads Points Setting ==================
export const getAdsPointsSettingApi = "admin/get-ads-points-settings"
export const updateAdsPointsSettingApi = "admin/update-ads-points-settings"
